import { Link, useNavigate } from 'react-router-dom'
import { Button, logo, UserRole } from '@valiant/ui-shared'
import { useNavigation } from '../contexts/NavigationContext'
import { TradeType, useGetMeQuery } from '../generated/graphql'
import { useAuth } from '../AuthProvider'
import { useState } from 'react'
import { DashboardMode } from './switch/DashboardMode'
import DynamicSelector from './switch/DynamicSelector'
import { ChevronLeft } from 'lucide-react'

export function DashboardNavbar({
  redirectOnSelect = true,
  hideBack = false,
}: {
  redirectOnSelect?: boolean
  hideBack?: boolean
}) {
  const {
    selectedGroupId,
    setSelectedGroupId,
    selectedCompanyId,
    setSelectedCompanyId,
    isSwapMode,
    setIsSwapMode,
    groupsData,
    groupsLoading,
    companiesData,
    companiesLoading,
  } = useNavigation()
  const navigate = useNavigate()
  const filteredCompanies = companiesData?.filter(
    (company) => company.tradeType !== TradeType.Deactivated,
  )

  // Get user role for conditional rendering
  const { auth } = useAuth()
  const userRole = auth?.role
  const [groupSearchValue, setGroupSearchValue] = useState('')
  const [companySearchValue, setCompanySearchValue] = useState('')
  const [groupComboboxOpen, setGroupComboboxOpen] = useState(false)
  const [companyComboboxOpen, setCompanyComboboxOpen] = useState(false)

  // Fetch user data
  const [{ data: userData }] = useGetMeQuery()

  const username = userData?.getMe?.username || 'User'

  // isScrolled now comes from MainLayout
  const LogoComponent = logo({ className: 'md:h-[28px] md:w-[28px] h-[36px] w-[36px]' })

  return (
    <div
      className={`flex md:min-h-[110px] items-center gap-4 px-4 md:px-14 md:pt-[46px] 
  min-h-[64px] transition-all duration-200`}
    >
      <div className="flex md:justify-between md:items-center md:min-h-16 w-full gap-4 md:gap-2 py-6 md:py-0 md:flex-wrap">
        {!hideBack && (
          <div className="flex gap-3 items-center md:hidden">
            <Button
              variant="main_action"
              className="h-9.5 w-9.5 rounded-md"
              onClick={() => navigate(-1)}
            >
              <ChevronLeft className="size-5" />
            </Button>
          </div>
        )}

        <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4 w-full md:w-auto">
          <div className="hidden md:flex flex-col md:flex-row md:items-center gap-2 md:gap-4">
            <div className="flex items-center gap-2 justify-between md:block">
              <Link
                to="/"
                className="flex items-center gap-2 text-lg font-semibold md:text-base shrink-0"
              >
                <LogoComponent />
              </Link>
            </div>
            <h1 className="text-xl font-bold">Welcome, {username}!</h1>
          </div>

          {/* Dynamic Selector - Group in Admin Mode, Company in Swap Mode */}
          <DynamicSelector
            redirectOnSelect={redirectOnSelect}
            isSwapMode={isSwapMode}
            selectedGroupId={selectedGroupId}
            selectedCompanyId={selectedCompanyId}
            groupsData={groupsData || []}
            companyData={filteredCompanies || []}
            groupSearchValue={groupSearchValue}
            setGroupSearchValue={setGroupSearchValue}
            companySearchValue={companySearchValue}
            setCompanySearchValue={setCompanySearchValue}
            groupComboboxOpen={groupComboboxOpen}
            setGroupComboboxOpen={setGroupComboboxOpen}
            groupsLoading={groupsLoading}
            companyComboboxOpen={companyComboboxOpen}
            setCompanyComboboxOpen={setCompanyComboboxOpen}
            companiesLoading={companiesLoading}
            setSelectedGroupId={setSelectedGroupId}
            setSelectedCompanyId={setSelectedCompanyId}
          />
        </div>

        <div className="flex items-center gap-4 shrink-0">
          {/* Mode Switch - Only show for non-USER roles */}
          {userRole !== UserRole.Trader ? (
            <DashboardMode
              isSwapMode={isSwapMode}
              setIsSwapMode={setIsSwapMode}
              clearSearchTerms={() => {
                setGroupSearchValue('')
                setCompanySearchValue('')
                setGroupComboboxOpen(false)
                setCompanyComboboxOpen(false)
              }}
            />
          ) : null}
        </div>
      </div>
    </div>
  )
}
